import { Toast } from "../../../../components/Common/Toast";
import { HTTPStatusEnum } from "../../../../interfaces/log.interface";
import { callAPI } from "../../../../services/api.service";

export const changeArtStyleStatus = async (artStyleId: string, getArtStyles: Function) => {
  try {
    const response = await callAPI(`admin/artstyle/status`, {
      artStyleId,
    });

    if (response?.status === HTTPStatusEnum.OK) {
      Toast("Art Style Status Updated Successfully");
      getArtStyles(); // Assuming getArtStyles is a function that updates the art styles
    } else {
      Toast(response?.message, true);
    }
  } catch (error) {
    Toast("Art Style Status Updated Failed", true);
  }
};

export const getAdminArtStyles = async (setArtStyles: (artStyle: any) => void) => {
  try {
      const response = await callAPI(`admin/artstyle`);
      if (response?.artStyle) setArtStyles(response?.artStyle);
      else Toast("Failed to get art styles", true);
  } catch (error) {
      Toast("Failed to get art styles", true);
  }
};